import { SlashMenuConfigExtension } from '@blocksuite/hive-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { CalloutKeymapExtension } from './callout-keymap';
import { calloutSlashMenuConfig } from './configs/slash-menu';

export const CalloutBlockSpec: ExtensionType[] = [
  FlavourExtension('hive:callout'),
  BlockViewExtension('hive:callout', literal`hive-callout`),
  CalloutKeymapExtension,
  SlashMenuConfigExtension('hive:callout', calloutSlashMenuConfig),
];
